module.exports = __webpack_public_path__ + "media/img/pages/companies/fenaco-f7d2faad60cd74a443220cc26559299f.png";